/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($, SCS, doc) {
	'use strict';
	/**
	 * Basic Skin implementation for the Default module.
	 *
	 * @author Rami Attallah
	 * @namespace Tc.Module.TableSorter
	 * @class DirectOrderFilter
	 * @extends Tc.Module
	 */

	Tc.Module.TableSorter.DirectOrderFilter = function(parent) {
		/**
		 * override the appropriate methods from the decorated module (ie. this.get = function()).
		 * the former/original method may be called via parent.<method>()
		 */
		this.on = function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				output = '',
				productGroups = [];

			mod.isMobile = SCS.utils.isMobilePage();

			if (mod.isMobile){
				mod.wrapLinks();
				mod.makeFilterCollapsible();
			}

			mod.$productGroup = $ctx.find('.product-group');

			mod.$productGroup.each(function() {
				productGroups.push($.trim($(this).text()));
			});

			if (productGroups.length > 1) {
				var len = $.distinct(productGroups).length;
				output += (mod.isMobile) ? '<ul class="direct-order-filter-list modScForm">' : '<ul class="direct-order-filter-list">';
				$.each($.distinct(productGroups), function( index, value ) {
					output += '<li' + ((len === index + 1) ? ' class="last"' : '') + '>';
					output += '<div class="custom-checkbox">';
					output += '<label><input type="checkbox" data-role="none" name="' + value + '" id="directOrderfilterCheckbox' + index + '" value="' + value + '"/>';
					output += '<span class="checkbox-control" role="checkbox" aria-checked="false" data-role="none"></span>' + value + '</label>';
					output += '</div>';
					output += '</li>';
				});

				output += '</ul>';
				$ctx.find('div.direct-order-container').append(output);
				$ctx.find('div.direct-order-container input:checkbox').scsCustomCheckbox();
			}

			$ctx.on('change', 'div.direct-order-container input:checkbox', function() {
				mod.filterTable(mod.getFilterValues());
				if (mod.isMobile) mod.toggleFilterInList(this);
			});

			mod.$ctx.on('click', '.filterParamRemove', function(){
				var id = $(this).closest('li').attr('data-id');
				$(doc.getElementById(id)).trigger('click');
			});

			// calling parent method
			parent.on(callback);
		};

		/**
		 *
		 * @returns {Array<String>}
		 */
		this.getFilterValues = function() {
			var mod = this,
				filterValues = [],
				$activeFilters = mod.$ctx.find('div.direct-order-container input:checkbox:checked');

			$activeFilters.each(function() {
				filterValues.push($(this).val());
			});

			return filterValues;
		};

		this.filterTable = function(filterValues) {

			var mod = this;

			if ($.isArray(filterValues) === false) {
				return false;
			}

			if (filterValues.length === 0) {
				mod.$productGroup.closest('tr').removeClass('is-hidden');
			} else {
				mod.$productGroup.each(function() {
					var productGroupValue = $.trim($(this).text());

					$(this).closest('tr').toggleClass('is-hidden', ($.inArray(productGroupValue, filterValues) === -1));

				});
			}

			return true;

		};

		/* Add necessary linklist markup for mobile version */
		this.wrapLinks = function() {
			var mod = this,
				$ctx = mod.$ctx;

			$('.product-detail-link', $ctx).each(function(){
				var $this = $(this),
					$toRemove = $this.parent();

				$this.appendTo($this.parent().prev('td'));
				$toRemove.remove();
			});

			$('.product-links', $ctx).append('<ul class="link-list"></ul>');

			$('.product-links > a, .product-links > span', $ctx).each(function(){
				var $this = $(this);
				$this.parent().find('br').remove();
				$this.appendTo($this.closest('.product-links').find('ul.link-list')).wrap('<li></li>');
			});

            /*  hide empty detail links for mobile */
            $('.product-detail-link', $ctx).each(function() {
                var $this = $(this);
                if ($this.attr('href') == '' || $this.text() == '' ) {
                    $this.parent().hide();
                } else {
                    $this.parent().show();
}
            });

		};

		this.makeFilterCollapsible = function() {
			var mod = this,
				$ctx = mod.$ctx;

			$ctx.find('.filter-title').append('<span class="arrow-down"></span>').wrapInner('<a href="#"></a>');

			$ctx.on('click', '.filter-title a', function(e){
				e.preventDefault();
				var $this = $(this),
					$arrow = $this.children('span');

				if ($arrow.hasClass('arrow-down')){
					$arrow.removeClass('arrow-down').addClass('arrow-up');
					$ctx.find('.direct-order-filter-list').slideDown(300);
				} else {
					$arrow.removeClass('arrow-up').addClass('arrow-down');
					$ctx.find('.direct-order-filter-list').slideUp(300);
				}

			});
		};

		this.toggleFilterInList = function(elem){
			var mod = this,
				$ctx = mod.$ctx,
				$elem = $(elem),
				id = $(elem).attr('id'),
				value = $(elem).val(),
				$filterList = ($ctx.find('.filter-breadcrumb').length) ? $ctx.find('.filter-breadcrumb') : $('<ul class="filter-breadcrumb"></ul>').insertAfter('.direct-order-filter-list', $ctx);

			if ($filterList.find('li[data-id="' + id + '"]').length){
				$filterList.find('li[data-id="' + id + '"]').remove();
				if (!$filterList.find('li').length) $filterList.remove();
			} else {
				$filterList.append('<li data-id="' + id + '">' + value + ' <span class="filterParamRemove close-icon"></span></li>');
			}
		};

	};
})(Tc.$, window.SCS, document);
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.TableSorter.DirectOrderFilter.js
// module id = 187
// module chunks = 0